var AuthQueryKeys={user:function user(id){return['auth','user',id];}};export{AuthQueryKeys};